import React, { useEffect, useState } from 'react';
import ConfigInput from '@/components/elements/ConfigInput';
import { CiEdit } from 'react-icons/ci';
import { MdDeleteOutline } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  ROLES,
  USER_CONSTANT_PROPS,
  USER_PROPS,
  getRole,
} from '@/constant/users/user.constant';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserRoles, getRoleNames } from '@/services/role';
import ConfirmActionModal, {
  DeleteIcon,
} from '@/components/organism/ConfirmActionModal';
import { deleteUser } from '@/services/user';
import { useToast } from '@/components/organism/Toast/ToastProvider';
import {
  deleteUserFailure,
  deleteUserSuccess,
  setShouldRefetchUsers,
} from '@/store/slices/user.slice';
import { authorizeRole } from '@/constant/global/global.constant';
import _ from 'lodash';
import { Text } from '@/components';
import EditUser from './EditUser';

const ViewUser = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [roleId, setRoleId] = useState('');
  const [selectedRole, setSelectedRole] = useState({});
  const [edit, setEdit] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { state } = useLocation();
  const [userLoaded, setUserLoaded] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const toast = useToast();
  const dispatch = useDispatch();
  const handleClose = () => {
    setIsOpen(false);
  };
  const userHasWriteAccess = _.includes(authorizeRole.USERS.CREATE, getRole());
  const roleNamesString = getRoleNames(
    state?.roleIds,
    state?.rolesInfo,
  )?.roleNameString;
  const getUser = async () => {
    setFirstName(state?.firstName);
    setLastName(state?.lastName);
    setEmail(state?.email);
    setRoleId(state?.roleId);
    setSelectedRole(state?.role);
    setUserLoaded(true);
    const res = await fetchUserRoles({ limit: 10, page: 1 });
  };

  if (state && !userLoaded) {
    getUser();
  }
  const handleShowmodal = () => {
    setIsDelete(true);
  };

  // Handling the function for delete user &&  popup :
  const handleDelete = async () => {
    try {
      const res = await deleteUser(state?.userId);
      history.back();
      toast?.pushSuccess(
        (res?.data as any)?.message,
        USER_CONSTANT_PROPS?.GENERIC?.TOAST_TIME,
      );
      dispatch(deleteUserSuccess(res?.data));
      dispatch(setShouldRefetchUsers(true));
      setIsDelete(false);
    } catch (error) {
      dispatch(deleteUserFailure(undefined));
      toast?.pushError(
        (error as any)?.response?.data?.message,
        USER_CONSTANT_PROPS?.GENERIC?.TOAST_TIME,
      );
      setIsDelete(false);
    }
  };

  return (
    <>
      <section className="w-full">
        <div className="flex m-auto">
          <div className="px-6 pt-6 pb-14 mx-auto">
            <div
              id="view_user_container"
              className="flex flex-row justify-between"
            >
              <Text
                as="h1"
                size="2xl"
                weight="semibold"
                color="default"
                className="flex py-6 px-3"
              >
                {!edit ? USER_PROPS.USER_DETAIL : USER_PROPS.EDIT_USER}
              </Text>
              {userHasWriteAccess && (
                <div id="view_user_action_button_wrapper" className="flex py-4">
                  <CiEdit
                    id="view_user_edit_action_button"
                    className="cursor-pointer mx-1 rounded-sm hover:bg-slate-200 shadow-sm"
                    size={26}
                    onClick={() => setIsOpen(!isOpen)}
                  />
                  <MdDeleteOutline
                    id="view_user_delete_action_button"
                    className="cursor-pointer mx-1 rounded-sm hover:bg-slate-200 shadow-sm"
                    size={26}
                    onClick={handleShowmodal}
                  />
                </div>
              )}
            </div>
            <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-2">
              <ConfigInput
                label={USER_PROPS.FIRST_NAME.LABEL}
                placeholder={USER_PROPS.FIRST_NAME.PLACEHOLDER}
                readOnly={!edit}
                value={firstName}
                name="firstName"
              />
              <ConfigInput
                label={USER_PROPS.LAST_NAME.LABEL}
                placeholder={USER_PROPS.LAST_NAME.PLACEHOLDER}
                value={lastName}
                readOnly={!edit}
                name="lastName"
              />
              <ConfigInput
                label={USER_PROPS.EMAIL_ID.LABEL}
                placeholder={USER_PROPS.EMAIL_ID.PLACEHOLDER}
                value={email}
                readOnly={!edit}
                name="email"
              />
              <ConfigInput
                label={USER_PROPS.ROLE.LABEL}
                placeholder={USER_PROPS.ROLE.PLACEHOLDER}
                value={roleNamesString}
                readOnly={!edit}
                name="role"
              />
            </div>
          </div>
        </div>
      </section>
      {isOpen && (
        <EditUser
          isOpen={isOpen}
          onClose={handleClose}
          firstName={firstName}
          lastName={lastName}
          email={email}
          roleSelected={roleId}
          userData={{
            firstName,
            lastName,
            email,
            selectedRole: state?.role,
            userId: state?.userId,
            authUserId: state?.authUserId,
            rolesDataInfo: {
              roleIds: state?.roleIds,
              selectedRoleNames: roleNamesString,
              selectedRolesInfo: getRoleNames(state?.roleIds, state?.rolesInfo)
                ?.selectedRolesInfo,
            },
          }}
        />
      )}

      {/* Confirmation model for delete user */}

      <ConfirmActionModal
        isOpen={isDelete}
        onClose={() => setIsDelete(false)}
        onConfirm={handleDelete}
        title={USER_CONSTANT_PROPS.VIEW_USER.DELETE_MODAL.TITLE}
        description={`${USER_CONSTANT_PROPS.VIEW_USER.DELETE_MODAL.DESCRIPTION_PREFIX}${state?.email}${USER_CONSTANT_PROPS.VIEW_USER.DELETE_MODAL.DESCRIPTION_SUFFIX}`}
        confirmWord={USER_CONSTANT_PROPS?.GENERIC?.DELETE}
        placeholder={USER_CONSTANT_PROPS.VIEW_USER.DELETE_MODAL.PLACEHOLDER}
        variant="danger"
        icon={<DeleteIcon />}
        confirmLabel={USER_CONSTANT_PROPS.VIEW_USER.DELETE_MODAL.CONFIRM_LABEL}
        confirmIcon={<DeleteIcon />}
        cancelLabel={USER_CONSTANT_PROPS.VIEW_USER.DELETE_MODAL.CANCEL}
      />
    </>
  );
};

export default ViewUser;
